module.exports = __webpack_public_path__ + "static/media/figure5.c491e145.png";